import { formatPhoneDisplay, normalizePhoneForCopy } from '@/lib/format-phone';
import { cn } from '@/lib/utils';
import type { MouseEvent } from 'react';

type CopyablePhoneProps = {
	value: string | null | undefined;
	onCopy: (text: string) => void;
	className?: string;
	prefix?: string;
	as?: 'button' | 'span';
	onClick?: (e: MouseEvent) => void;
};

export default function CopyablePhone({
	value,
	onCopy,
	className,
	prefix,
	as = 'button',
	onClick,
}: CopyablePhoneProps) {
	if (!value?.trim()) return null;

	const display = formatPhoneDisplay(value);
	const copyValue = normalizePhoneForCopy(value);

	function handleClick(e: MouseEvent) {
		e.stopPropagation();
		onClick?.(e);
		onCopy(copyValue);
	}

	const content = (
		<>
			{prefix}
			{display}
		</>
	);

	if (as === 'span') {
		return (
			<span
				className={cn('tabular-nums hover:bg-accent cursor-pointer select-none', className)}
				onClick={handleClick}
			>
				{content}
			</span>
		);
	}

	return (
		<button
			type='button'
			className={cn('tabular-nums hover:bg-accent cursor-pointer select-none text-left', className)}
			onClick={handleClick}
		>
			{content}
		</button>
	);
}
